import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Backdrop from "@/theme/Backdrop";

const SiteLayout = ({
  children,
  withFooter = true,
  withBackdrop = true,
  autoBackdrop = false,
}) => (
  <div className="min-h-screen flex flex-col" style={{ background: "#060606", color: "#fff" }}>
    {withBackdrop && <Backdrop auto={autoBackdrop} />}
    <Header />
    <main className="flex-1 relative z-10">{children}</main>
    {withFooter && <Footer />}
  </div>
);

export default SiteLayout;
